import React from "react";
import { useMediaQuery } from "@mui/material";

import { ProgressBar } from "./ProgressBar";
import { ProgressBarProvider } from "./ProgressBarProvider";
import { StyledProgressBarContainer } from "./styled";
import { useProgressBar } from "./hooks/useProgressBar";
import { ICONS, Icon } from "../Icons";

const renderSteps = (steps, isMobile, currentStepName) => {
  return steps.map((step, index) => {
    if (isMobile && currentStepName !== step.name) {
      return null;
    }

    return (
      <div
        className={isMobile ? "mobileProgressBarContainer" : "desktopProgressBarContainer"}
        key={index}
      >
        {isMobile ? (
          <div className="mobileProgressContainer">
            <div className="mobileProgressBarLabel">
              <Icon className={"progressBarIcon"} name={ICONS.progressIcon} alt="selected icon" />
              <span className="mobileProgressLabelStepName">{step.name}</span>
            </div>
            <ProgressBar
              label={step.name}
              value={step?.value}
              status={step?.status}
              isMobile={isMobile}
            />
          </div>
        ) : (
          <ProgressBar label={step.name} value={step?.value} status={step?.status} />
        )}
      </div>
    );
  });
};

export const ProgressBarContainer = () => {
  const isMobile = useMediaQuery("(max-width: 768px)") || window.innerWidth < 768;
  const { showProgressBar, steps, currentStepName } = useProgressBar(isMobile);

  return (
    showProgressBar > -1 && (
      <StyledProgressBarContainer>
        {renderSteps(steps, isMobile, currentStepName)}
      </StyledProgressBarContainer>
    )
  );
};

const HeaderProgressBar = () => {
  return (
    <ProgressBarProvider>
      <ProgressBarContainer />
    </ProgressBarProvider>
  );
};

export default HeaderProgressBar;
